import { useState } from "react";

/** Ask a session to start a background agent: a name, its task in full, and whether it gets a branch of its own. */
export function NewAgentModal({
  sessionLabel,
  onClose,
  onStart,
}: {
  sessionLabel: string;
  onClose: () => void;
  onStart: (agent: { label: string; task: string; worktree: boolean }) => void;
}) {
  const [label, setLabel] = useState("");
  const [task, setTask] = useState("");
  const [worktree, setWorktree] = useState(true);
  const canStart = label.trim() !== "" && task.trim() !== "";

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>New agent</h3>
        <p className="muted">
          {sessionLabel} starts a background session for this task. It reports back to {sessionLabel} when it&apos;s
          done, and shows up under it here.
        </p>
        <input
          className="group-title-input"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder="Name, e.g. Fix login redirect"
          maxLength={80}
          autoFocus
        />
        <textarea
          className="agent-task-input"
          value={task}
          onChange={(e) => setTask(e.target.value)}
          placeholder="The task, in full: the agent starts with nothing else"
          rows={6}
        />
        <label className="group-picker-row">
          <input type="checkbox" checked={worktree} onChange={(e) => setWorktree(e.target.checked)} />
          <span className="label">Own branch and worktree (when the session is in a git repository)</span>
        </label>
        <div className="modal-actions">
          <button className="linkish" onClick={onClose}>
            Cancel
          </button>
          <button disabled={!canStart} onClick={() => onStart({ label: label.trim(), task: task.trim(), worktree })}>
            Start
          </button>
        </div>
      </div>
    </div>
  );
}
